module.exports = __webpack_public_path__ + "img/man_tipping_hand.91be1e2b.gif";